import { take, fork, select, put, call, delay} from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from "../../config/config";
import {getClubUnion, getCurrentClubAdminToken, getCurrentClubId} from "../selectors";
import {showNotification} from "../actionCreators/notification";
import {
    acceptDeclineSuccess,
    createUnionSuccess,
    disbandUnionSuccess,
    joinUnionSuccess, quitUnionClubSuccess,
    unionMembersSuccess,
    unionPendingsSuccess,
    changeUnionDetailsSuccess,
} from "../actionCreators/union";
import { createBrowserHistory } from 'history';
import { dataURLtoFile } from './helpers/club';
import {checkAuthentication} from "../actionCreators/authentication";
const browserHistory = createBrowserHistory();

function* createUnion( unionName ) {
    console.log('createUnion: unionName: ', unionName);
    try {
        const token = yield select(getCurrentClubAdminToken);
        const response = yield call(callApi, `${config.API_URL}/club/union`, 'POST', {username: unionName, token});

        yield put(createUnionSuccess(response.data.result.account));
        yield put(showNotification({message: `Successfully created the ${unionName} union.`}));
    } catch (e) {}
}

function* joinUnion( unionId ) {
    console.log('joinUnion: unionName: ', unionId);
    try {
        const token = yield select(getCurrentClubAdminToken);
        yield call(callApi, `${config.API_URL}/club/unionPendingAccount`, 'POST', { unionId, token });

        yield put(joinUnionSuccess());
        yield put(showNotification({message: `Successfully sent the join request.`}));
    } catch (e) {}
}

function* disbandUnion( unionId ) {
    console.log('disbandUnion: unionId: ', unionId);
    try {
        const token = yield select(getCurrentClubAdminToken);
        yield call(callApi, `${config.API_URL}/club/union/${unionId}`, 'DELETE', { token });

        // yield put(checkAuthentication());
        yield put(disbandUnionSuccess());
        yield browserHistory.goBack();
        yield put(showNotification({message: `Successfully disbanded the union.`}));
    } catch (e) {}
}

function* quitUnionClub( unionId ) {
    console.log('quitUnionClub: unionId: ', unionId);
    try {
        const clubId = yield select(getCurrentClubId);
        const token = yield select(getCurrentClubAdminToken);
        yield call(callApi, `${config.API_URL}/club/union/${unionId}/account/${clubId}`, 'DELETE', { token });

        yield put(quitUnionClubSuccess());
        yield browserHistory.goBack();
        yield put(showNotification({message: `Successfully quit the union.`}));
    } catch (e) {}
}

function* getClubs( unionId ) {
    console.log('getClubs: unionId: ', unionId);
    try {
        const token = yield select(getCurrentClubAdminToken);
        const response = yield call(callApi, `${config.API_URL}/club/union/${unionId}/account`, 'GET', { token });

        // yield put(checkAuthentication());
        yield put(unionMembersSuccess(response.data.result.accounts));

    } catch (e) {}
}

function* getPendings( unionId ) {
    console.log('getClubs: unionId: ', unionId);
    try {
        const token = yield select(getCurrentClubAdminToken);
        const response = yield call(callApi, `${config.API_URL}/club/union/${unionId}/pendingAccount`, 'GET', { token });

        // yield put(checkAuthentication());
        yield put(unionPendingsSuccess(response.data.result.unionPendingAccounts));

    } catch (e) {}
}
function* acceptDeclineRequest({ clubId, doAccept }) {
    console.log('acceptDeclineRequest: clubId: ', clubId);
    try {
        const token = yield select(getCurrentClubAdminToken);
        const union = yield select(getClubUnion);
        const params = {
            accountId: clubId,
            status: doAccept ? 'accepted' : 'declined',
            token
        };
        yield call(callApi, `${config.API_URL}/club/unionPendingAccount/${union._id}`, 'PATCH', params );
        yield put(acceptDeclineSuccess(union._id));
        yield put(showNotification({message: `Successfully ${doAccept ? 'accepted' : 'declined'} the club`}));
    } catch (e) {}
}

function* changeUnionDetails ({ unionName, unionAvatar, unionId }) {
    try {
        const token = yield select();
        const unionId = unionId;

        if ( !!unionName ) {
            //also here should be handled club name change but it is disabled for now as before
            yield call(callApi, `${config.API_URL}/club/clubInfo/${unionId}`, 'PATCH', { name: unionName, token });
        }

        if ( unionAvatar ) {
            const headers = {
                'Content-Type': 'multipart/form-data',
                'x-access-token': token
            };
            const file = dataURLtoFile(unionAvatar.data);
            const data = new FormData();
            data.append('avatar', file);

            yield call(callApi, `${config.API_MEDIA_URL}/uploadAvatar`, 'POST', data, headers);
        }
        yield put(showNotification({message: 'Successfully updated the unione.'}));
        yield put(changeUnionDetailsSuccess({unionId, name: unionName}));
    } catch (e) {}
}

//  Watchers
////////////////////////////////////////////////////////////////////
//
export function* watchCreateUnion() {
    while (true) {
        const action = yield take(actionTypes.CREATE_UNION_REQUEST);
        yield fork(createUnion, action.name);
    }
}
export function* watchJoinUnion() {
    while (true) {
        const action = yield take(actionTypes.JOIN_UNION_REQUEST);
        yield fork(joinUnion, action.unionId);
    }
}
export function* watchDisbandUnion() {
    while (true) {
        const action = yield take(actionTypes.DISBAND_UNION_REQUEST);
        yield fork(disbandUnion, action.unionId);
    }
}
export function* watchQuitUnionClub() {
    while (true) {
        const action = yield take(actionTypes.QUIT_UNION_CLUB_REQUEST);
        yield fork(quitUnionClub, action.unionId);
    }
}
export function* watchUnionMembers() {
    while (true) {
        const action = yield take([actionTypes.UNION_MEMBERS_REQUEST, actionTypes.UNION_ACCEPT_DECLINE_CLUB_SUCCESS]);
        yield fork(getClubs, action.unionId);
    }
}
export function* watchUnionPendings() {
    while (true) {
        const action = yield take([actionTypes.UNION_PENDINGS_REQUEST, actionTypes.UNION_ACCEPT_DECLINE_CLUB_SUCCESS]);
        yield fork(getPendings, action.unionId);
    }
}
export function* watchUnionAcceptDeclineClub() {
    while (true) {
        const action = yield take(actionTypes.UNION_ACCEPT_DECLINE_CLUB_REQUEST);
        yield fork(acceptDeclineRequest, action);
    }
}
export function* watchUnionEdit() {
    while (true) {
        const action = yield take(actionTypes.UNION_CHANGE_REQUEST);
        yield fork(changeUnionDetails, action.unionDetails);
    }
}
